module.exports = __webpack_public_path__ + "img/2928733.0ff9ee20.svg";